var React = require('react');

function PlayPoligon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 10L-8.74228e-07 20L0 -6.99382e-07L16 10Z","fill":"white"}));
}

PlayPoligon.defaultProps = {"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none"};

module.exports = PlayPoligon;

PlayPoligon.default = PlayPoligon;
